<template>
  <div>
    <form class="needs-validation" @submit.prevent="submitCreatePartnerProfitOrder">

      <div class="form-group">
        <label for="partnerData_contractDate">Дата платежного поручения</label>
        <input
            id="partnerData_contractDate"
            v-model="partnerProfitOrderData.order_date"
            type="date"
            class="form-control form-control-sm"
        />
        <div v-if="submitted && $v.partnerProfitOrderData.order_date" class="invalid-feedback">
          <span v-if="!$v.partnerProfitOrderData.order_date.minLength">
            {{$t('validatePhrases.minLength')}}: 10
          </span>
          <span v-if="!$v.partnerProfitOrderData.order_date.maxLength">
            {{$t('validatePhrases.maxLength')}}: 10
          </span>
        </div>
      </div>

      <div class="form-group">
        <label for="with_nds">Номер платежного поручения</label>
        <input
            id="with_nds"
            v-model="partnerProfitOrderData.number"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.partnerProfitOrderData.number.$error }"
        />
      </div>

      <div class="form-group">
        <label for="partnerData_contractDate">Дата начала периода</label>
        <input
            id="partnerData_contractDate"
            v-model="partnerProfitOrderData.start_period"
            type="date"
            class="form-control form-control-sm"
        />
        <div v-if="submitted && $v.partnerProfitOrderData.start_period" class="invalid-feedback">
          <span v-if="!$v.partnerProfitOrderData.start_period.minLength">
            {{$t('validatePhrases.minLength')}}: 10
          </span>
          <span v-if="!$v.partnerProfitOrderData.start_period.maxLength">
            {{$t('validatePhrases.maxLength')}}: 10
          </span>
        </div>
      </div>

      <div class="form-group">
        <label for="partnerData_contractDate">Дата окончания периода</label>
        <input
            id="partnerData_contractDate"
            v-model="partnerProfitOrderData.end_period"
            type="date"
            class="form-control form-control-sm"
        />
        <div v-if="submitted && $v.partnerProfitOrderData.end_period.$error" class="invalid-feedback">
          <span v-if="!$v.partnerData.contract_date.minLength">
            {{$t('validatePhrases.minLength')}}: 10
          </span>
          <span v-if="!$v.partnerProfitOrderData.end_period.maxLength">
            {{$t('validatePhrases.maxLength')}}: 10
          </span>
        </div>
      </div>

    </form>
  </div>

</template>

<script>

import {integer, email, maxLength, maxValue, minLength, minValue, required} from "vuelidate/lib/validators";

import axios from "axios";

export default {
  // mixins: [validationMixin],
  name: "CreatePartnerProfitOrder",
  data() {
    return {
      partnerProfitOrderData: {
        partner_id: null,
        number: null,
        order_date: null,
        start_period: null,
        end_period: null
      },
      submitted: false
    }
  },
  mounted() {

  },
  props: {
    // submitPartnerProfitOrder: Number
  },
  watch: {
    // submitCreatePartnerProfitOrder: function (val) {
    //   if (val > 0) {
    //     this.submitCreatePartnerProfitOrder();
    //   }
    // }
  },
  computed: {

  },
  validations: {
    partnerProfitOrderData: {
      start_period: {minLength: minLength(1), maxLength: maxLength(255)},
      end_period: {minLength: minLength(1), maxLength: maxLength(255)},
    },
  },
  methods: {
    setNullFormDate() {
      this.partnerProfitOrderData = {
        partner_id: null,
            number: null,
            order_date: null,
            start_period: null,
            end_period: null
      };
    },
    submitCreatePartnerProfitOrder() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.partnerProfitOrderData.$touch();
      if (!this.$v.partnerProfitOrderData.$invalid) {
        this.$emit('submitCreatePartnerProfitOrder', this.partnerProfitOrderData);
      }
    },
    generatePartnerProfitOrder(){
      let formData = new FormData();
      formData.append('id', this.partnerProfitOrderData.partner_id);
      formData.append('number', this.partnerProfitOrderData.number);
      formData.append('order_date', this.partnerProfitOrderData.order_date);
      formData.append('start_period', this.partnerProfitOrderData.start_period);
      formData.append('end_period', this.partnerProfitOrderData.end_period);
      axios
          .post(`/v1/partners/generate-profit-payment-order`, formData)
          .then(resp => {
            this.$emit('new-profit-order-created');
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          })
      ;
    },
  },
  created() {

  }
};
</script>

<style scoped lang="css">

</style>
